import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_ATIS_API_BASE_URL,
  //headers:{'Access-Control-Allow-Origin' : 'http://localhost:3000'}
  //"https://api.atissystem.fr/api/v1",
  
  //process.env.ATIS_API_BASE_URL,
  
  //baseURL: ""
  //"http://localhost:8080",
  //(process.env.NODE_ENV = "development"
  //  ? "http://localhost:8080/"
  //    : "https://api.atissystem.fr/"),
  // "https://api.atissystem.fr/" // process.env.NODE_ENV==="development" ? 'http://localhost:8080' : 'https://api.atissystem.fr/',
  
});

instance.interceptors.request.use(
  async config => {
    const token = localStorage.getItem("token");
    //console.log(`Bearer ${token}`);
    
    if (null != token) {
      config.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return config;
  }
);
/*instance.interceptors.response.use(
  async response => {
    console.log(response);
    if (response.status == 401) {

    }
    return response
  }, async function(error) {
    const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry) {
    
  }
  return Promise.reject(error);
)*/
export default instance;



// WEBPACK FOOTER //
// ./src/axios-atis.js